const defaultSettings = {
  title: "Kinetic Platform",
}


export default defaultSettings;
